<template>
  <div class="TrafficDecision">
    <FieldSet
      :label="label"
      :values="values"
      :fields="fields"
      :validation="validation"
      :layout="layout"
      :disabled="disabled"
      :path="path"
      @input="handleInput"
      @change="handleChange"
    />
  </div>
</template>

<script>
import FieldSet from '@/components/form/FieldSet'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'TrafficDecision',
  components: { FieldSet },
  props: {
    label: {
      type: String,
      default: 'Verkeersbesluit',
    },
    values: {
      type: Object,
      default: () => {},
    },
    path: {
      type: String,
      default: 'TrafficDecision',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      disableDateFields: false,
      layout: [
        {
        'columns': '1fr',
        'fields': ['TrafficDecisionNotApplicable'],
        },
        {
        'columns': '1fr',
        'fields': ['PublicationDate'],
        },
        {
        'columns': '1fr',
        'fields': ['DefinitiveDate'],
        },
      ],
    }
  },
  computed: {
    fields () {
      return {
        ...(!this.isDateDisabled ? {
          'PublicationDate': {
            'type': 'string',
            'title': 'Publicatie verkeersbesluit',
            'disabled': this.isDateDisabled,
            'format': 'date',
        },
        'DefinitiveDate': {
            'type': 'string',
            'title': 'Einddatum bezwaarperiode',
            'disabled': this.isDateDisabled,
            'format': 'date',
        },
        } : {}),
        'TrafficDecisionNotApplicable': {
          'type': 'toggle',
          'title': 'Verkeersbesluit niet van toepassing',
          'format': 'toggle',
        },
      }
    },
    validation () {
      return {
        PublicationDate: {
          required: !this.isDateDisabled ? required : {},
        },
        DefinitiveDate: {
          required: !this.isDateDisabled ? required : {},
        },
      }
    },
    isDateDisabled () {
      return this.disableDateFields
    },
  },
  created () {
    if (this.values[this.path]?.TrafficDecisionNotApplicable) {
      this.disableDateFields = true
    }
  },
  methods: {
    handleInput({ name, value }) {
      if (['TrafficDecision.PublicationDate'].includes(name) && value) {
        const trafficDecision = {
          PublicationDate: value,
          DefinitiveDate: this.format(this.addDays(new Date(value), 43)),
          TrafficDecisionNotApplicable: false
        }

        this.$emit('setDefinitiveDate', { trafficDecision })
      }
    },
    handleChange (event) {
      this.disableDateFields = event

      const trafficDecision = {
        TrafficDecisionNotApplicable: event
      }

      this.$emit('setDefinitiveDate', { trafficDecision })
    },
    addDays(date, days) {
      const copy = new Date(Number(date))
      copy.setDate(date.getDate() + days)
      return copy
    },
    format(date) {
      let month = '' + (date.getMonth() + 1)
      let day = '' + date.getDate()
      let year = date.getFullYear()

      month = month.length < 2 ? `0${month}` : month
      day = day.length < 2 ? `0${day}` : day

      return `${year}-${month}-${day}`
    },
  },
}
</script>
